"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptFormEsignature = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles = __importStar(require("./AcceptFormEsignature.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var AcceptFlowContextProvider_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowContextProvider");
var Printable_1 = require("./Printable");
var SignatureSlot_1 = require("@CommonFrontend/Public/Widgets/EsignComponents/SignatureSlot/SignatureSlot");
var AcceptFlowGlobalStore_1 = __importDefault(require("@CommonFrontend/AcceptFlow/AcceptFlowGlobalStore"));
var mobx_react_1 = require("mobx-react");
var Esignature_1 = require("@CommonFrontend/Esignature");
var AcceptFormEsignature = function () {
    var _a = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), isPrintMode = _a.isPrintMode, acceptersDataStore = _a.acceptersDataStore;
    var formContext = (0, react_1.useContext)(kaleidoscope_1.FormContext);
    if (isPrintMode) {
        return react_1.default.createElement(Printable_1.PrintableEsignatureStylingV2, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_final_form_1.Field, { name: "esignature", initialValue: "", validate: function (value) {
                if (!value) {
                    return "Please sign to accept the document";
                }
            }, parse: lodash_1.identity }, function (fieldProps) {
            var _a, _b;
            var error = ((_a = fieldProps.meta.data) === null || _a === void 0 ? void 0 : _a.showValidationErrors) ? fieldProps.meta.error : undefined;
            return (react_1.default.createElement(SignatureComponent, { onBlur: function () {
                    fieldProps.input.onBlur();
                }, onFocus: function () {
                    fieldProps.input.onFocus();
                }, onChange: function (signature, method) {
                    var _a;
                    fieldProps.input.onChange(signature);
                    (_a = formContext === null || formContext === void 0 ? void 0 : formContext.form) === null || _a === void 0 ? void 0 : _a.change("signatureMethod", method);
                }, error: error, value: (_b = formContext === null || formContext === void 0 ? void 0 : formContext.values["esignature"]) !== null && _b !== void 0 ? _b : "", accepterName: formContext === null || formContext === void 0 ? void 0 : formContext.values["name"], acceptersDataStore: acceptersDataStore }));
        }),
        react_1.default.createElement(kaleidoscope_1.ValidationSpy, { name: "esignature", mutators: formContext === null || formContext === void 0 ? void 0 : formContext.mutators })));
};
exports.AcceptFormEsignature = AcceptFormEsignature;
var SignatureComponent = (0, mobx_react_1.observer)(function (_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, formError = _a.error, formValue = _a.value, accepterName = _a.accepterName, acceptersDataStore = _a.acceptersDataStore;
    var globalStore = AcceptFlowGlobalStore_1.default.getInstance();
    var accepterStoreIndex = AcceptFlowGlobalStore_1.default.getInstance().getAllDataStores().length - 1;
    var _b = __read((0, react_1.useState)(!!formValue), 2), showingSignature = _b[0], setShowingSignature = _b[1];
    var disconnectDataStore = !acceptersDataStore;
    var isSlotFilledAnywhere = function () {
        if (globalStore.currentSlot === null || disconnectDataStore)
            return false;
        return globalStore.isSlotFilledInAnyStore(globalStore.currentSlot, "signature");
    };
    var handleClearSignature = function () {
        if (disconnectDataStore) {
            onChange("", Esignature_1.SignatureInputMethod.Typed);
        }
        else {
            if (globalStore.currentSlot === null)
                return;
            acceptersDataStore.clearSignature(globalStore.currentSlot, { clearIndex: false });
        }
    };
    var updateSignature = function (signature, method) {
        if (disconnectDataStore) {
            onChange(signature, method);
            setShowingSignature(!!signature);
        }
        else {
            if (globalStore.currentSlot === null)
                return;
            globalStore.updateTargetSignatureAndFilledStores({
                slotIndex: globalStore.currentSlot,
                storeIndex: accepterStoreIndex,
                signature: signature,
                method: method,
            });
            setShowingSignature(!!signature);
        }
    };
    var getAcceptData = (0, react_1.useCallback)(function () {
        if (globalStore.currentSlot === null || disconnectDataStore)
            return null;
        return acceptersDataStore.accepterSlots[globalStore.currentSlot];
    }, [globalStore.currentSlot, disconnectDataStore, acceptersDataStore]);
    var getStoredSignature = function () {
        var _a, _b;
        if (globalStore.currentSlot === null || disconnectDataStore)
            return "";
        return (_b = (_a = acceptersDataStore.accepterSlots[globalStore.currentSlot]) === null || _a === void 0 ? void 0 : _a.signature) !== null && _b !== void 0 ? _b : "";
    };
    var handleSlotClick = function () {
        var _a;
        if (globalStore.currentSlot === null || disconnectDataStore)
            return;
        var acceptData = getAcceptData();
        if (acceptData === null || acceptData === void 0 ? void 0 : acceptData.signature) {
            onChange(acceptData.signature, (_a = acceptData.signatureMethod) !== null && _a !== void 0 ? _a : Esignature_1.SignatureInputMethod.Typed);
        }
        else {
            globalStore.copySignatureFromOtherStores(globalStore.currentSlot, acceptersDataStore);
        }
    };
    var storedSignature = getStoredSignature();
    (0, react_1.useEffect)(function () {
        if (disconnectDataStore) {
            return;
        }
        var acceptData = getAcceptData();
        var signature = acceptData === null || acceptData === void 0 ? void 0 : acceptData.signature;
        var signatureMethod = acceptData === null || acceptData === void 0 ? void 0 : acceptData.signatureMethod;
        if (signature && signature !== formValue) {
            onChange(acceptData.signature, signatureMethod !== null && signatureMethod !== void 0 ? signatureMethod : Esignature_1.SignatureInputMethod.Typed);
            setShowingSignature(true);
        }
        if (!signature && formValue) {
            onChange("", Esignature_1.SignatureInputMethod.Typed);
            setShowingSignature(false);
        }
    }, [formValue, onChange, storedSignature, getAcceptData, disconnectDataStore]);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: showingSignature ? "m" : undefined },
        react_1.default.createElement(kaleidoscope_1.Label, { long: true, className: styles.label }, "E-signature"),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs" },
            react_1.default.createElement(SignatureSlot_1.SignatureSlot, { isEditable: true, onClear: handleClearSignature, onBlur: onBlur, onFocus: onFocus, name: accepterName !== null && accepterName !== void 0 ? accepterName : "", alwaysHideName: true, data: !!formValue ? formValue : null, type: SignatureSlot_1.SlotType.Signature, onChange: function (_a) {
                    var signature = _a.signature, method = _a.method;
                    updateSignature(signature, method);
                }, dateStamp: new Date().toString(), isSlotFilledAnywhere: isSlotFilledAnywhere(), onSlotClick: handleSlotClick, labelStyle: "name", size: "large", isAccepted: false, zIndexStart: 0 }),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!formError, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement("div", { ref: expandableElementRef, className: styles.error },
                    react_1.default.createElement(icons_1.Warning, { "aria-hidden": true, size: icons_1.IconSize.Small, className: styles.errorIcon }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.errorText, "aria-live": "polite" }, formError)));
            }))));
});
